import { ApiError, createApiClient } from '@gl/api-client';
import { clearStoredToken, getStoredToken } from './token';

export const API_URL = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000').replace(/\/+$/, '');
export const PUBLIC_MENU_BASE_URL = (
  import.meta.env.VITE_PUBLIC_MENU_BASE_URL ?? 'http://localhost:5174'
).replace(/\/+$/, '');

/** Se dispara cuando la API responde 401: AuthProvider escucha y cierra la sesión. */
export const UNAUTHORIZED_EVENT = 'gl:unauthorized';

/**
 * Instancia única del cliente. Los módulos de la fase B usan sus factories con esta instancia:
 *   import { catalogApi } from '@gl/api-client';
 *   const catalog = catalogApi(api);
 */
export const api = createApiClient({
  baseUrl: API_URL,
  getToken: getStoredToken,
  onUnauthorized: () => {
    clearStoredToken();
    window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
  },
});

/** Mensaje legible para mostrar en toasts / formularios. */
export function errorMessage(err: unknown, fallback = 'Algo salió mal, probá de nuevo'): string {
  if (err instanceof ApiError) return err.message || fallback;
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}

export { ApiError };
